import MuiPaper, { type PaperProps } from '@mui/material/Paper';

export type { PaperProps };

const Paper = ({ elevation = 2, ...props }: PaperProps) => (
  <MuiPaper elevation={elevation} {...props} />
);

export default Paper;
